const initTikTokSlider = () => {
    const slides = document.querySelectorAll(".slidev8");

    const pauseAllVideos = (exceptVideo) => {
        document.querySelectorAll(".tiktok-videov8").forEach(v => {
            if (v !== exceptVideo) {
                v.pause();
                v.classList.remove("playingv8");
                const slide = v.closest('.slidev8');
                if (slide) {
                    slide.querySelector(".play-buttonv8").style.display = "flex";
                    slide.querySelector(".pause-buttonv8").style.display = "none";
                }
            }
        });
    };

    slides.forEach(slide => {
        const playButton = slide.querySelector(".play-buttonv8");
        const pauseButton = slide.querySelector(".pause-buttonv8");
        const muteButton = slide.querySelector(".mute-buttonv8");
        const video = slide.querySelector("video");

        if (!video || !playButton || !pauseButton || !muteButton) return;

        let hidePauseButtonTimeout;

        const showPauseButton = () => {
            if (!video.paused) {
                pauseButton.classList.remove("hiddenv8");
                clearTimeout(hidePauseButtonTimeout);
                hidePauseButtonTimeout = setTimeout(() => {
                    pauseButton.classList.add("hiddenv8");
                }, 1000);
            }
        };

        const playVideo = () => {
            pauseAllVideos(video);
            video.play().catch(error => {
                console.log("Video play failed:", error);
                // Si falla la reproducción, intentamos con mute
                if (!video.muted) {
                    video.muted = true;
                    muteButton.textContent = "🔇";
                    // Intentamos reproducir de nuevo
                    video.play().catch(error => {
                        console.log("Video play failed even when muted:", error);
                    });
                    // Mostramos un mensaje al usuario
                    alert("Para reproducir el video automáticamente, necesitamos silenciarlo primero. Puedes activar el sonido manualmente.");
                }
            });
            video.classList.add("playingv8");
            playButton.style.display = "none";
            pauseButton.style.display = "flex";
            showPauseButton();
        };

        const pauseVideo = () => {
            video.pause();
            video.classList.remove("playingv8");
            playButton.style.display = "flex";
            pauseButton.style.display = "none";
        };

        const toggleMute = () => {
            video.muted = !video.muted;
            muteButton.textContent = video.muted ? "🔇" : "🔊";
        };

        // Event Listeners
        playButton.addEventListener("click", playVideo);
        pauseButton.addEventListener("click", pauseVideo);
        muteButton.addEventListener("click", toggleMute);

        video.addEventListener("click", () => {
            if (video.paused) {
                playVideo();
            } else {
                pauseVideo();
            }
        });

        video.addEventListener("play", () => {
            playButton.style.display = "none";
            pauseButton.style.display = "flex";
            showPauseButton();
        });

        video.addEventListener("pause", () => {
            playButton.style.display = "flex";
            pauseButton.style.display = "none";
        });

        video.addEventListener("mousemove", showPauseButton);

        // Establecer estado inicial del botón de mute
        muteButton.textContent = video.muted ? "🔇" : "🔊";
    });
};

// Initialize on page load
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTikTokSlider);
} else {
    initTikTokSlider();
}

// Re-initialize when Shopify section is reloaded
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTikTokSlider);
} 